// eslint-disable-next-line import/prefer-default-export
export enum ImportType {
  // CREATE / READ
  AGENCY_MULTIPLE = "agency-multiple",
  DOCKYARD_EDB = "dockyard-edb",
  DOCKYARD_MULTIPLE = "dockyard-multiple",
  DOCKYARD_SIMPLE = "dockyard-simple",
  EDB = "edb",
  ORDER = "order",
  ORDER_EXPORT = "order-export",
  PRODUCT = "product",
  PROJECT = "project",
  STOCK = "stock",
  RECEPTION = "reception",

  // We sometimes needs two differents exports type for the same "entity" (Reception, order,...)
  // One for the creation and one for exporting datas with more infos (status, ... )
  // and which doesn't filters out elements that can't be updated
  RECEPTION_READ = "reception-read",
  EDB_READ = "edb-read",

  // UPDATE
  PRODUCT_UPDATE = "product-update",
  ORDER_UPDATE = "order-update",

  DOCKYARD_EDB_UPDATE = "dockyard-edb-update",
  EDB_UPDATE = "edb-update",
  DOCKYARD_SIMPLE_UPDATE = "dockyard-simple-update",
  DOCKYARD_MULTIPLE_UPDATE = "dockyard-multiple-update",
  PROJECT_UPDATE = "project-update",

  // DELETE
  PRODUCT_DELETE = "product-delete",
}

export type ImportError = {
  message: string;
  line: number;
  column: string;
  severity?: string;
};
